import { createMetricsFactory } from 'metrics-js';
const Metrics = createMetricsFactory('automation-ui-canvas');
export default Metrics;